export const colWidths = [
    50, //TaskId
    40, //Client/Entity
    40, //Client Number
    40, //Description
    40, //Task Type
    30, //Period End Date
    50, //Task Status
    30, //Due Date
]